import {
	Autocomplete,
	Button,
	IconButton,
	InputAdornment,
	Tab,
	Tabs,
	TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import Clientes from "../administracao/clientes";
import {
	Add,
	Clear,
	FilterAltOutlined,
	PersonAddAlt1Outlined,
	Search,
} from "@mui/icons-material";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import FilterBar from "../../components/topBarFilter";
import Staff from "../administracao/staff";
export default function Usuarios() {
	const theme = useTheme();
	const styles = useStyles(theme);
	const [value, setValue] = useState(0);
	const [openFilterEquipe, setOpenFilterEquipe] = useState(false);
	const [openFilterClient, setOpenFilterClient] = useState(false);
	const [buscarUsuarioEquipe, setBuscarUsuarioEquipe] = useState("");
	const [buscarUsuarioClient, setBuscarUsuarioClient] = useState("");
	const [selectCliente, setSelectCliente] = useState("");
	const [openModalAddUserEquipe, setOpenModalAddUserEquipe] = useState(false);
	const [openModalAddUserClient, setOpenModalAddUserClient] = useState(false);
	const [allClientes, setAllClientes] = useState([]);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const actionsEquipe = [
		{
			icon: <FilterAltOutlined />,
			name: "Filtro",
			onClick: () => setOpenFilterEquipe(true),
		},
		{
			icon: <PersonAddAlt1Outlined />,
			name: "Novo Usuário",
			onClick: () => setOpenModalAddUserEquipe(true),
		},
	];

	const actionsClient = [
		{
			icon: <FilterAltOutlined />,
			name: "Filtro",
			onClick: () => setOpenFilterClient(true),
		},
		{
			icon: <PersonAddAlt1Outlined />,
			name: "Novo Usuário Cliente",
			onClick: () => setOpenModalAddUserClient(true),
		},
	];

	return (
		<Box>
			{value === 0 && (
				<FilterBar
					actions={actionsEquipe}
					openFilter={openFilterEquipe}
					setOpenFilter={setOpenFilterEquipe}
					selectorComponentLeft={
						<TextField
							variant="outlined"
							label="Buscar usuário"
							value={buscarUsuarioEquipe}
							size="small"
							onChange={(event) => {
								setBuscarUsuarioEquipe(event.target.value);
							}}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Search />
									</InputAdornment>
								),
								endAdornment: buscarUsuarioEquipe ? (
									<InputAdornment position="end">
										<IconButton
											onClick={() => setBuscarUsuarioEquipe("")}
											edge="end"
										>
											<Clear />
										</IconButton>
									</InputAdornment>
								) : null,
							}}
							sx={styles.searcField}
						/>
					}
					selectorComponentRight={
						<Button
							endIcon={<Add sx={styles.containerAdd} />}
							onClick={() => setOpenModalAddUserEquipe(true)}
							sx={styles.buttomAddUser}
							variant="outlined"
						>
							Novo Usuário
						</Button>
					}
				/>
			)}
			{value === 1 && (
				<FilterBar
					actions={actionsClient}
					openFilter={openFilterClient}
					setOpenFilter={setOpenFilterClient}
					selectorComponentLeft={
						<Box sx={{ display: "flex", gap: 1 }}>
							<TextField
								variant="outlined"
								label="Buscar usuário"
								value={buscarUsuarioClient}
								size="small"
								onChange={(event) => {
									setBuscarUsuarioClient(event.target.value);
								}}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<Search />
										</InputAdornment>
									),
									endAdornment: buscarUsuarioClient ? (
										<InputAdornment position="end">
											<IconButton
												onClick={() => setBuscarUsuarioClient("")}
												edge="end"
											>
												<Clear />
											</IconButton>
										</InputAdornment>
									) : null,
								}}
								sx={styles.searcField}
							/>
							<Autocomplete
								size="small"
								disablePortal
								options={allClientes}
								getOptionLabel={(option) =>
									option
										? `${option?.clienteErpId || ""} - ${
												option?.nomeFantasia || option?.razaoSocial || ""
											}`
										: ""
								}
								sx={styles.clientAutocomplete}
								onChange={(event, cliente) => {
									setSelectCliente(cliente?.nomeFantasia);
								}}
								renderInput={(params) => (
									<TextField {...params} label="Cliente" />
								)}
							/>
						</Box>
					}
					selectorComponentRight={
						<Button
							endIcon={<Add sx={styles.containerAdd} />}
							onClick={() => setOpenModalAddUserClient(true)}
							sx={styles.buttomAddUser}
							variant="outlined"
						>
							Novo Usuário
						</Button>
					}
				/>
			)}

			<>
				<Staff
					openFilter={openFilterEquipe}
					setOpenFilter={setOpenFilterEquipe}
					buscarUsuario={buscarUsuarioEquipe}
					setBuscarUsuario={setBuscarUsuarioEquipe}
					setOpenModalAddUser={setOpenModalAddUserEquipe}
					openModalAddUser={openModalAddUserEquipe}
				/>
			</>
		</Box>
	);
}
